export enum CampaignScoreValues {
	BAD = '0',
	POOR = '1',
	OKAY = '2',
	GOOD = '3',
	EXCELLENT = '4',
}

export type CampaignFormQuestion = {
	id: string
	label: string
	type: 'text' | 'select' | 'open_text' | 'file' | 'datetime'
	attribute: 'phone' | 'email' | 'name' | 'contact_consent' | 'cv' | null
	subtype: 'name' | 'email' | 'phone' | 'multiple' | null
	weight?: number
	validationRules?: string[] | null
	scores?: Array<{
		questionId: string
		optionId: string
		scoreValue: CampaignScoreValues
	}>
	options?: Array<{
		id: string
		label: string
		isDisqualifying?: boolean
		consentType?: string | null
	}>
	optionsModified?: boolean
}
export type CampaignForm = {
	id: string
	questions: Array<CampaignFormQuestion>
}
